// Module
var code = "";
// Exports
var _module_exports =code;;
var path = '/viraweb123/vw-dashboard/src/modules/shop/controllers/show-image-dialog.html';
window.angular.module('mblowfishApp').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;